frontApp.orderItemToggle = {
  init() {
    this.toggleDetail();
    this.expandAllEvent();
    this.collapseAllEvent();
  },
  toggleDetail() {
    document.addEventListener('click', (event) => {
      const { target } = event;

      const curBtn = target.closest('.js-orders-item-toggle');
      if (!curBtn) {
        return false;
      }

      const currentItem = curBtn.closest('.js-orders-item');
      const activeElements = currentItem.querySelectorAll('.js-orders-item-detail, .js-orders-item-head, .js-orders-item-toggle');

      if (curBtn.classList.contains('is-active')) {
        currentItem.classList.remove('is-active');
        activeElements.forEach((el) => {
          el.classList.remove('is-active');
        });
      } else {
        currentItem.classList.add('is-active');
        activeElements.forEach((el) => {
          el.classList.add('is-active');
        });
      }
    });
  },
  expandAllEvent() {
    document.addEventListener('click', (event) => {
      const { target } = event;

      const curBtn = target.closest('.js-orders-expand-all');
      if (!curBtn) {
        return false;
      }

      this.expandAll();
    });
  },
  collapseAllEvent() {
    document.addEventListener('click', (event) => {
      const { target } = event;

      const curBtn = target.closest('.js-orders-collapse-all');
      if (!curBtn) {
        return false;
      }

      this.collapseAll();
    });
  },
  expandAll() {
    const activeElements = document.querySelectorAll('.js-orders-item-detail, .js-orders-item-head, .js-orders-item-toggle');
    activeElements.forEach((el) => {
      el.classList.add('is-active');
    });
  },
  collapseAll() {
    const activeElements = document.querySelectorAll('.js-orders-item-detail, .js-orders-item-head, .js-orders-item-toggle');
    activeElements.forEach((el) => {
      el.classList.remove('is-active');
    });
  },
};
